import { FC, useEffect, useMemo, useState } from "react";
import ChatGptMarkdown from "../chatgpt-markdown";
import ChatGptAvatar from "../../../icons/chatgpt-avatar";
import styles from "./index.module.scss";
import { UserInfo } from "../../../types";
import { getUserInfo } from "../../../api";
import cn from "classnames";

export type Chat = {
  key: string | number;
  input: string;
  result: string;
};

interface ChatItemProps {
  dataSource: Chat;
}

const ChatItem: FC<ChatItemProps> = ({ dataSource }) => {
  const { input, result } = dataSource;
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const thinking = useMemo(() => {
    return !(result || "").trim();
  }, [result]);

  useEffect(() => {
    getUserInfo().then((userInfo) => {
      setUserInfo(userInfo);
    });
  }, []);

  return (
    <>
      <div className={styles.line}>
        <span className={cn(styles.avatar, styles.userAvatar)}>
          {!!userInfo ? <img src={userInfo.avatar} alt="" /> : "U"}
        </span>
        <div className={cn(styles.content, styles.userInput)}>{input}</div>
      </div>
      <div className={styles.line}>
        <span className={styles.avatar}>
          <ChatGptAvatar />
        </span>
        <div className={styles.content}>
          {thinking ? (
            <ChatGptMarkdown>思考中...</ChatGptMarkdown>
          ) : (
            <ChatGptMarkdown>{result}</ChatGptMarkdown>
          )}
        </div>
      </div>
    </>
  );
};

export default ChatItem;
